import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@vfa-cp/shared';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
const configJson = JSON.parse(<any>localStorage.getItem('vfa-cp-storage-config'));
export class CustomLoader implements TranslateLoader {

  constructor(private http: HttpClient) {
  }  

  public getTranslation(lang: string): Observable<any> {
    let headers = {};
    if(configJson.APIGEE_API_KEY) {
      headers = { 'apiKey': configJson.APIGEE_API_KEY }
    }
    return this.http.get(`${configJson.BASEURL_SETTINGS_API}/v1/translation?locale=${lang}`, { headers }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(errorApi => {
        return this.http.get(`./assets/i18n/en-GB.json`).pipe(
          map((res => {
            return res;
          })),
          catchError(error => {
            return error;
          })
        );
      })
    );
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader, // enable when retrieving data from API
        // useFactory: HttpLoaderFactory, // enable when using static json translations
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    // {provide: APP_BASE_HREF, useValue: configJson.BASE_HREF}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
